import { createSlice } from "@reduxjs/toolkit";
import * as _ser from "../_apiHelpers/ProjectsApihelper";
import * as _msg from "../../_utilities/message";
import { updateLoader } from "../LoaderSlice";
import { updateSnackbar } from "../SnackbarSlice";
import { GetTimeZone } from "../../_utilities/GetTimeZone";

const initalState = { data: null, message: "" };
const initialSnackbar = { type: "", message: "" };

export const getProjectsSlice = createSlice({
  name: "GetProjects",
  initialState: initalState,
  reducers: {
    getProjectsStartReducer: (state) => ({ ...state, data: null }),
    getProjectsReducer: (state, action) => {
      const { status, data, message } = action.payload || {};
      if (status === 200 && data?.data) {
        const projectData = data.data?.rows?.map((item) => ({
          ...item,
          status: item.status === 1 ? "Active" : "Inactive",
          createdDate: GetTimeZone(item.createdDate),
        }));
        return {
          ...state,
          data: { rows: projectData, total_count: data.data?.total_count },
          message,
        };
      }
      return { ...state, message, data: null };
    },
  },
});

export const { getProjectsReducer, getProjectsStartReducer } =
  getProjectsSlice.actions;
export const getProjectsAsync = (payload) => async (dispatch) => {
  dispatch(updateLoader(true));
  dispatch(updateSnackbar(initialSnackbar));
  const res = await _ser.GetProjects(payload);
  dispatch(updateLoader(false));
  dispatch(getProjectsReducer(res));
};

export const getProjectsByIdSlice = createSlice({
  name: "GetProjectsById",
  initialState: initalState,
  reducers: {
    getProjectsByIdStartReducer: (state, action) => {
      return { ...state, data: null };
    },
    getProjectsByIdReducer: (state, action) => {
      const { status, data, message } = action.payload || {};
      if (status === 200 && data?.data) {
        const projectData = data.data?.map((item) => ({
          ...item,
          createdDate: GetTimeZone(item.createdDate),
        }));
        return { ...state, data: projectData, message };
      }
      return { ...state, message, data: null };
    },
  },
});
export const { getProjectsByIdReducer, getProjectsByIdStartReducer } =
  getProjectsByIdSlice.actions;
export const getProjectsByIdAsync = (id) => async (dispatch) => {
  dispatch(updateLoader(true));
  dispatch(updateSnackbar(initialSnackbar));
  const res = await _ser.GetProjectById(id);
  dispatch(updateLoader(false));
  dispatch(getProjectsByIdReducer(res));
};

export const getProjectJobByIdSlice = createSlice({
  name: "GetProjectJobById",
  initialState: initalState,
  reducers: {
    getProjectJobByIdStartReducer: (state, action) => {
      return { ...state, data: null };
    },
    getProjectJobByIdReducer: (state, action) => {
      const { status, data, message } = action.payload || {};
      if (status === 200 && data?.data) {
        return { ...state, data: data.data, message };
      }
      return { ...state, message, data: null };
    },
  },
});
export const { getProjectJobByIdReducer, getProjectJobByIdStartReducer } =
  getProjectJobByIdSlice.actions;
export const getProjectJobByIdAsync =
  (projectId, jobId) => async (dispatch) => {
    dispatch(updateLoader(true));
    dispatch(updateSnackbar(initialSnackbar));
    dispatch(getProjectJobByIdStartReducer());
    const res = await _ser.GetProjectJobById(projectId, jobId);
    dispatch(updateLoader(false));
    dispatch(getProjectJobByIdReducer(res));
  };

export const addProjectsSlice = createSlice({
  name: "AddProjects",
  initialState: initalState,
  reducers: {
    addProjectsStartReducer: (state, action) => {
      return { ...state, data: null };
    },
    addProjectsReducer: (state, action) => {
      return {
        ...state,
        message: action.payload.data?.message || "",
        data: action.payload.data?.code || null,
      };
    },
  },
});
export const { addProjectsReducer, addProjectsStartReducer } =
  addProjectsSlice.actions;
export const addProjectsAsync = (data) => async (dispatch) => {
  dispatch(updateLoader(true));
  dispatch(updateSnackbar(initialSnackbar));
  const res = await _ser.AddProjects(data);
  dispatch(updateLoader(false));
  dispatch(addProjectsReducer(res));
  setTimeout(() => {
    dispatch(
      updateSnackbar({
        type: res?.data?.code === 200 ? "success" : "error",
        message: res?.data?.message || "",
      }),
    );
  }, 500);
};

export const editProjectsSlice = createSlice({
  name: "EditProjects",
  initialState: initalState,
  reducers: {
    editProjectsStartReducer: (state, action) => {
      return { ...state, data: null };
    },
    editProjectsReducer: (state, action) => {
      return {
        ...state,
        message: action.payload.data?.message || "",
        data: action.payload.data?.code || null,
      };
    },
  },
});
export const { editProjectsReducer, editProjectsStartReducer } =
  editProjectsSlice.actions;
export const editProjectsAsync = (id, data) => async (dispatch) => {
  dispatch(updateLoader(true));
  dispatch(updateSnackbar(initialSnackbar));
  const res = await _ser.EditProjects(id, data);
  dispatch(updateLoader(false));
  dispatch(editProjectsReducer(res));
  setTimeout(() => {
    dispatch(
      updateSnackbar({
        type: res?.data?.code === 200 ? "success" : "error",
        message: res?.data?.message || "",
      }),
    );
  }, 500);
};

export const getAccessibleToSlice = createSlice({
  name: "GetAccessibleTo",
  initialState: initalState,
  reducers: {
    getAccessibleToStartReducer: (state, action) => {
      return { ...state, data: null, isLoading: false };
    },
    getAccessibleToReducer: (state, action) => {
      const { status, data } = action.payload || {};
      if (status === 200 && data?.user) {
        const accessibleTo = data?.user.map((item) => ({
          id: item.id,
          fullName: `${item.firstName} ${item.lastName}`,
        }));
        return {
          ...state,
          data: accessibleTo,
          message: action.payload.data.message,
          isloader: false,
        };
      } else {
        return {
          ...state,
          message: action.payload?.data.message,
          data: null,
          isloader: false,
        };
      }
    },
  },
});
export const { getAccessibleToReducer, getAccessibleToStartReducer } =
  getAccessibleToSlice.actions;
export const getAccessibleToAsync = (id) => async (dispatch) => {
  dispatch(updateLoader(true));
  dispatch(updateSnackbar(initialSnackbar));
  const res = await _ser.GetAccessibleTo(id);
  dispatch(getAccessibleToReducer(res));
  dispatch(updateLoader(false));
};

export const getProjectApplicantsSlice = createSlice({
  name: "GetProjectApplicants",
  initialState: initalState,
  reducers: {
    getProjectApplicantsStartReducer: (state, action) => {
      return { ...state, data: null, isLoading: false };
    },
    getProjectApplicantsReducer: (state, action) => {
      const { status, data, message } = action.payload || {};
      if (status === 200 && data?.data) {
        if (action.payload.data) {
          const associateApplicants = data.data?.rows?.map((list) => ({
            ...list,
            isChecked: false,
          }));
          return {
            ...state,
            data: {
              rows: associateApplicants,
              total_count: data?.data.total_count,
            },
            message: data.message,
            isloader: false,
          };
        }
      } else {
        return { ...state, message: data.message, data: null, isloader: false };
      }
    },
  },
});
export const { getProjectApplicantsReducer, getProjectApplicantsStartReducer } =
  getProjectApplicantsSlice.actions;
export const getProjectApplicantsAsync = (data) => async (dispatch) => {
  dispatch(updateLoader(true));
  dispatch(updateSnackbar(initialSnackbar));
  const res = await _ser.GetProjectApplicants(data);
  dispatch(getProjectApplicantsReducer(res));
  dispatch(updateLoader(false));
};

export const addAssociateProjectApplicantsSlice = createSlice({
  name: "AddAssociateProjectApplicants",
  initialState: initalState,
  reducers: {
    addAssociateProjectApplicantsStartReducer: (state, action) => {
      return { ...state, data: null, isLoading: false };
    },
    addAssociateProjectApplicantsReducer: (state, action) => {
      return {
        ...state,
        message: action.payload.data?.message || "",
        data: action.payload.data?.code || null,
      };
    },
  },
});
export const {
  addAssociateProjectApplicantsReducer,
  addAssociateProjectApplicantsStartReducer,
} = addAssociateProjectApplicantsSlice.actions;
export const addAssociateProjectApplicantsAsync =
  (data) => async (dispatch) => {
    dispatch(updateLoader(true));
    dispatch(updateSnackbar(initialSnackbar));
    const res = await _ser.AddAssociateProjectApplicants(data);
    dispatch(addAssociateProjectApplicantsReducer(res));
    dispatch(updateLoader(false));
    setTimeout(() => {
      dispatch(
        updateSnackbar({
          type: res?.data?.code === 200 ? "success" : "error",
          message: res?.data?.message || "",
        }),
      );
    }, 500);
  };

export const getProjectsCommentsSlice = createSlice({
  name: "GetProjectsComments",
  initialState: initalState,
  reducers: {
    getProjectsCommentsStartReducer: (state, action) => {
      return { ...state, data: null, isLoading: false };
    },
    getProjectsCommentsReducer: (state, action) => {
      if (action.payload?.status === 200) {
        if (action.payload.data) {
          return {
            ...state,
            data: action.payload.data.auditlogs,
            message: action.payload.data.message,
            isloader: false,
          };
        }
      } else {
        return {
          ...state,
          message: action.payload?.data.message,
          data: null,
          isloader: false,
        };
      }
    },
  },
});
export const { getProjectsCommentsReducer, getProjectsCommentsStartReducer } =
  getProjectsCommentsSlice.actions;
export const getProjectsCommentsAsync = (data) => async (dispatch) => {
  dispatch(updateLoader(true));
  dispatch(updateSnackbar(initialSnackbar));
  const res = await _ser.GetProjectsComments(data);
  dispatch(getProjectsCommentsReducer(res));
  dispatch(updateLoader(false));
};

export const deleteProjectApplicantsSlice = createSlice({
  name: "DeleteProjectApplicants",
  initialState: initalState,
  reducers: {
    deleteProjectApplicantsStartReducer: (state, action) => {
      return { ...state, data: null, isLoading: false };
    },
    deleteProjectApplicantsReducer: (state, action) => {
      if (action.payload?.status === 200 && action.payload.data) {
        return {
          ...state,
          data: action.payload.data?.code,
          message: action.payload.data.message,
          isloader: false,
        };
      } else {
        return {
          ...state,
          message: action.payload?.data?.message || "",
          data: null,
          isloader: false,
        };
      }
    },
  },
});
export const {
  deleteProjectApplicantsReducer,
  deleteProjectApplicantsStartReducer,
} = deleteProjectApplicantsSlice.actions;
export const deleteProjectApplicantsAsync = (data) => async (dispatch) => {
  dispatch(updateLoader(true));
  dispatch(updateSnackbar(initialSnackbar));
  const res = await _ser.DeleteProjectApplicants(data);
  dispatch(deleteProjectApplicantsReducer(res));
  dispatch(updateLoader(false));
  setTimeout(() => {
    dispatch(
      updateSnackbar({
        type: res?.data?.code === 200 ? "success" : "error",
        message: res?.data?.message || "",
      }),
    );
  }, 500);
};

export const deleteProjectJobsSlice = createSlice({
  name: "DeleteProjectJobs",
  initialState: initalState,
  reducers: {
    deleteProjectJobsStartReducer: (state, action) => {
      return { ...state, data: null, isLoading: false };
    },
    deleteProjectJobsReducer: (state, action) => {
      if (action.payload?.status === 200 && action.payload.data) {
        return {
          ...state,
          data: action.payload.data?.code,
          message: action.payload.data.message,
          isloader: false,
        };
      } else {
        return {
          ...state,
          message: action.payload?.data?.message || "",
          data: null,
          isloader: false,
        };
      }
    },
  },
});
export const { deleteProjectJobsReducer, deleteProjectJobsStartReducer } =
  deleteProjectJobsSlice.actions;
export const deleteProjectJobsAsync = (data) => async (dispatch) => {
  dispatch(updateLoader(true));
  dispatch(updateSnackbar(initialSnackbar));
  const res = await _ser.DeleteProjectJobs(data);
  dispatch(deleteProjectJobsReducer(res));
  dispatch(updateLoader(false));
  setTimeout(() => {
    dispatch(
      updateSnackbar({
        type: res?.data?.code === 200 ? "success" : "error",
        message: res?.data?.message || "",
      }),
    );
  }, 500);
};

export const updateProjectJobStatusSlice = createSlice({
  name: "UpdateProjectJobStatus",
  initialState: initalState,
  reducers: {
    updateProjectJobStatusStartReducer: (state, action) => {
      return { ...state, data: null, isLoading: false };
    },
    updateProjectJobStatusReducer: (state, action) => {
      return {
        ...state,
        message: action.payload.data?.message || "",
        data: action.payload.data?.code || null,
      };
    },
  },
});
export const {
  updateProjectJobStatusReducer,
  updateProjectJobStatusStartReducer,
} = updateProjectJobStatusSlice.actions;
export const updateProjectJobStatusAsync =
  (projectId, data) => async (dispatch) => {
    dispatch(updateLoader(true));
    dispatch(updateSnackbar(initialSnackbar));
    const res = await _ser.UpdateProjectJobStatus(projectId, data);
    dispatch(updateProjectJobStatusReducer(res));
    dispatch(updateLoader(false));
    setTimeout(() => {
      dispatch(
        updateSnackbar({
          type: res?.data?.code === 200 ? "success" : "error",
          message: res?.data?.message || "",
        }),
      );
    }, 500);
  };

export const getProjectJobsSlice = createSlice({
  name: "GetProjectJobs",
  initialState: initalState,
  reducers: {
    getProjectJobsStartReducer: (state, action) => {
      return { ...state, data: null, isLoading: false };
    },
    getProjectJobsReducer: (state, action) => {
      const { status, data, message } = action.payload || {};
      if (status === 200 && data?.data) {
        return {
          ...state,
          data: data.data,
          message: data.message,
          isloader: false,
        };
      } else {
        return {
          ...state,
          message: data?.message,
          data: null,
          isloader: false,
        };
      }
    },
  },
});
export const { getProjectJobsReducer, getProjectJobsStartReducer } =
  getProjectJobsSlice.actions;
export const getProjectJobsAsync = (data) => async (dispatch) => {
  dispatch(updateLoader(true));
  dispatch(updateSnackbar(initialSnackbar));
  const res = await _ser.GetProjectJobs(data);
  dispatch(getProjectJobsReducer(res));
  dispatch(updateLoader(false));
};

export const addAssociateProjectJobsSlice = createSlice({
  name: "AddAssociateProjectJobs",
  initialState: initalState,
  reducers: {
    addAssociateProjectJobsStartReducer: (state, action) => {
      return { ...state, data: null, isLoading: false };
    },
    addAssociateProjectJobsReducer: (state, action) => {
      return {
        ...state,
        message: action.payload.data?.message || "",
        data: action.payload.data?.code || null,
      };
    },
  },
});
export const {
  addAssociateProjectJobsReducer,
  addAssociateProjectJobsStartReducer,
} = addAssociateProjectJobsSlice.actions;
export const addAssociateProjectJobsAsync = (data) => async (dispatch) => {
  dispatch(updateLoader(true));
  dispatch(updateSnackbar(initialSnackbar));
  const res = await _ser.AddAssociateProjectJobs(data);
  dispatch(addAssociateProjectJobsReducer(res));
  dispatch(updateLoader(false));
  setTimeout(() => {
    dispatch(
      updateSnackbar({
        type: res?.data?.code === 200 ? "success" : "error",
        message: res?.data?.message || "",
      }),
    );
  }, 500);
};

export const getProjectsByApplicantIdSlice = createSlice({
  name: "GetProjectsByApplicantId",
  initialState: initalState,
  reducers: {
    getProjectsByApplicantIdStartReducer: (state) => ({ ...state, data: null }),
    getProjectsByApplicantIdReducer: (state, action) => {
      const { status, data, message } = action.payload || {};
      if (status === 200 && data?.data) {
        return {
          ...state,
          data: data.data,
          message,
        };
      }
      return { ...state, message, data: null };
    },
  },
});

export const {
  getProjectsByApplicantIdReducer,
  getProjectsByApplicantIdStartReducer,
} = getProjectsByApplicantIdSlice.actions;

export const getProjectsByApplicantIdAsync = (id) => async (dispatch) => {
  dispatch(updateLoader(true));
  dispatch(updateSnackbar(initialSnackbar));
  const res = await _ser.GetProjectsByApplicantId(id);
  dispatch(updateLoader(false));
  dispatch(getProjectsByApplicantIdReducer(res));
};

export const getProjectsByJobPostingIdSlice = createSlice({
  name: "GetProjectsByJobPostingId",
  initialState: initalState,
  reducers: {
    getProjectsByJobPostingIdStartReducer: (state) => ({ ...state, data: null }),
    getProjectsByJobPostingIdReducer: (state, action) => {
      const { status, data, message } = action.payload || {};
      if (status === 200 && data?.data) {
        return {
          ...state,
          data: data.data,
          message,
        };
      }
      return { ...state, message, data: null };
    },
  },
});

export const {
  getProjectsByJobPostingIdReducer,
  getProjectsByJobPostingIdStartReducer,
} = getProjectsByJobPostingIdSlice.actions;

export const getProjectsByJobPostingIdAsync = (id) => async (dispatch) => {
  dispatch(updateLoader(true));
  dispatch(updateSnackbar(initialSnackbar));
  const res = await _ser.GetProjectsByJobPostingId(id);
  dispatch(getProjectsByJobPostingIdReducer(res));
  dispatch(updateLoader(false));
};